import axios from "axios"
import { updateRows } from "./CommonFunctions";

const url = process.env.REACT_APP_SERVER_URL

export const getTenancyById = async(tenancyId)=>{
    try{
        const response = await axios.get(`${url}/tenants/${tenancyId}`);
        if(response && response.data && response.data.length>0){
            return response.data[0];
        }
        return {};
    }
    catch(error){
        console.log(error);
    }
}

export const updateTenancyById = async(tenancyId, tenancyJson) =>{
    try{
        const response = await axios.patch(`${url}/tenants/${tenancyId}`, tenancyJson);
        console.log(response)
        if(response && response.data){
            return response.data;
        }

    }
    catch(error){
        console.log(error);
    }
}

export const createTenancy = async(tenancyJson) =>{
    try{
        const response = await axios.post(`${url}/tenants`, tenancyJson);
        if(response){
            return response.data;
        }
        return null;

    }
    catch(error){
        console.log(error);
    }
}

export const getCustomersByTenancyId = async(tenancyId)=>{
    try{
        const response = await axios.get(`${url}/tenants/${tenancyId}/customers`);
        if(response && response.data){
            console.log(response.data)
            return response.data;
        }
        return [];
    }
    catch(error){
        console.log(error);
    }
}

export const getPaymentsByTenancyId = async(tenancyId)=>{
    try{
        const response = await axios.get(`${url}/paymentHistory/${tenancyId}`);
        if(response && response.data){
            return response.data;
        }
        return [];
    }
    catch(error){
        console.log(error);
    }
}
//Add customer
//FIX ME: //Add Customer tenancy relation
export const createCustomer = async(customerJson)=>{
    try{
        const response = await axios.post(`${url}/customers`, customerJson);
        if(response && response.data){
            return response.data;
        }
        return {};
    }
    catch(error){
        console.log(error);
    }
}
//Edit Customer
export const updateCustomer = async(customerId ,customerJson)=>{
    try{
        const response = await axios.patch(`${url}/customers/${customerId}`, customerJson);
        if(response && response.data){
            return response.data;
        }
        return {};
    }
    catch(error){
        console.log(error);
    }
}
//Add Customer tenancy relation
export const createCustomerTenancy = async(tenancyId, customerId)=>{
    try{
        const response = await axios.post(`${url}/tenants/addRelation`, {
                tenantId:tenancyId,
                customerid:customerId,
              })
    }
    catch(error){
        console.log(error);
    }
}
//Delete Customer tenancy relation
export const deleteCustomerTenancy = async(tenancyId, customerId, customersDetails=[])=>{
    try{
        const response = await axios.delete(`${url}/tenants/${tenancyId}/customers/${customerId}`);
        if(response){
            updateRows(customersDetails, "delete", customerId);
        }
        
    }
    catch(error){
        console.log(error);
    }
}

export const getVacantRoomsByDate = async (searchStartDate, searchEndDate) => {
    try {
        if (searchStartDate == null || searchEndDate == null) {
            alert('Select Both searchStartDate and searchEndDate Dates')
            return [];
        }
        const response = await axios.post(`${url}/vRoomsByDate`, {
            searchStartDate,
            searchEndDate,
        })
        if(response && response.data){
            console.log(response.data)
            return response.data;
        }
        return [];
    } catch (error) {
      console.log(error)
    }
  }

// ========================================
// V2 API FUNCTIONS - PROPER VACANCY TRACKING
// ========================================

// Create draft reservation
export const createDraftTenancy = async (data) => {
  try {
    const response = await axios.post(`${url}/v2/tenants/draft`, data);
    return response.data;
  } catch (error) {
    console.error("Create draft error:", error);
    throw error;
  }
};

// Walk-in check-in
export const checkInTenancy = async (data) => {
  try {
    const response = await axios.post(`${url}/v2/tenants/checkin`, data);
    return response.data;
  } catch (error) {
    console.error("Check-in error:", error);
    throw error;
  }
};

// Activate draft (draft → active)
export const activateDraftTenancy = async (tenancyId) => {
  try {
    const response = await axios.put(`${url}/v2/tenants/${tenancyId}/activate`);
    return response.data;
  } catch (error) {
    console.error("Activate draft error:", error);
    throw error;
  }
};

// Checkout
export const checkoutTenancy = async (tenancyId, actualCheckoutDate) => {
  try {
    const response = await axios.put(`${url}/v2/tenants/${tenancyId}/checkout`, {
      actualCheckoutDate
    });
    return response.data;
  } catch (error) {
    console.error("Checkout error:", error);
    throw error;
  }
};

// Update checkout date
export const updateCheckoutDateTenancy = async (tenancyId, actualCheckoutDate) => {
  try {
    const response = await axios.put(`${url}/v2/tenants/${tenancyId}/checkout-date`, {
      actualCheckoutDate
    });
    return response.data;
  } catch (error) {
    console.error("Update checkout date error:", error);
    throw error;
  }
};

// Renew tenancy
export const renewTenancy = async (tenancyId, data) => {
  try {
    const response = await axios.post(`${url}/v2/tenants/${tenancyId}/renew`, data);
    return response.data;
  } catch (error) {
    console.error("Renew error:", error);
    throw error;
  }
};

// Change room
export const changeRoomTenancy = async (tenancyId, newRoomId) => {
  try {
    const response = await axios.post(`${url}/v2/tenants/${tenancyId}/change-room`, {
      newRoomId
    });
    return response.data;
  } catch (error) {
    console.error("Change room error:", error);
    throw error;
  }
};

export const getDocumentTemplatesList = async () => {
    try{
      const response = await axios.get(`/api/templates`);
      if(response && response.data){
        return response.data.templates;
      }

    }catch(error){
      console.error("Error fetching document templates:", error);
    }
};


// Create a customer review record (step 1 — creates the review itself, tied to the tenancy)
export const createCustomerReview = async (tenancyId, reviewJson) => {
    try {
        const response = await axios.post(`${url}/tenants/${tenancyId}/customerReviews`, {
            tenancyId,
            ...reviewJson,
        });
        if (response && response.data) {
            return response.data;
        }
        return null;
    }
    catch (error) {
        console.log(error);
    }
}
 
// Link a created review to a specific customer (step 2)
export const linkCustomerReview = async (reviewId, customerId) => {
    try {
        const response = await axios.post(`${url}/customers_reviews`, {
            reviewId,
            customerId,
        });
        if (response && response.data) {
            return response.data;
        }
        return null;
    }
    catch (error) {
        console.log(error);
    }
}
 
// Update an existing review
export const updateCustomerReview = async (reviewId, reviewJson) => {
    try {
        const response = await axios.patch(`${url}/updateCustomerReview/${reviewId}`, reviewJson);
        if (response && response.data) {
            return response.data;
        }
        return null;
    }
    catch (error) {
        console.log(error);
    }
}
 
// Delete a review
export const deleteCustomerReview = async (tenancyId, reviewId) => {
    try {
        const response = await axios.delete(`${url}/tenants/${tenancyId}/customerReviews/${reviewId}`);
        if (response && response.data) {
            return response.data;
        }
        return null;
    }
    catch (error) {
        console.log(error);
    }
}
 
// Get all reviews for a tenancy (raw customerReviews rows only — no customerId
// link, so this CANNOT be filtered down to a single guest's reviews)
export const getCustomerReviewsByTenantId = async (tenancyId) => {
    try {
        const response = await axios.get(`${url}/tenants/${tenancyId}/customerReviews`);
        if (response && response.data) {
            return response.data;
        }
        return [];
    }
    catch (error) {
        console.log(error);
    }
}
 
// Get a customer's full review history (used on GuestDetails — per-guest view)
export const getReviewsByCustomerId = async (customerId) => {
    try {
        const response = await axios.get(`${url}/getReviewsByCustomerId/${customerId}`);
        if (response && response.data) {
            return response.data;
        }
        return [];
    }
    catch (error) {
        console.log(error);
    }
}
 
// Get all reviews for a tenancy (for places that need the whole-tenancy view,
// not scoped to a single guest)
export const getReviewsByTenantId = async (tenantId) => {
    try {
        const response = await axios.get(`${url}/getReviewsByTenantId/${tenantId}`);
        if (response && response.data) {
            return response.data;
        }
        return [];
    }
    catch (error) {
        console.log(error);
    }
}
 
// Get ALL reviews across every tenancy, joined with the customer link table
// (customerReviews -> customers_reviews_trans -> customers), so each row
// includes a `customerId`. This is the only endpoint with that link today,
// so callers filter client-side by customerId for a single guest's reviews.
// NOTE: the backend query is `select *` across 3 joined tables with no column
// aliases, so duplicate column names (e.g. `id`) get silently overwritten by
// the last-joined table. Use `reviewId` and `customerId` (from the join table,
// collision-free) to identify rows — do not rely on `id`.
export const getAllCustomerReviews = async () => {
    try {
        const response = await axios.get(`${url}/reviews`);
        if (response && response.data) {
            return response.data;
        }
        return [];
    }
    catch (error) {
        console.log(error);
    }
}

//Phase 2:
//Checkin

//Checkout


//Renew

//Review

//Edit tenancy

//Phase 3:
//Change Room

//Void room


